/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserUpdate { 
    RoleId?: string | null;
    Name?: string | null;
    Surname?: string | null;
    Email?: string | null;
    Id: string;
    CustomerId?: string | null;
}

